import type { Content, LinkToMediaField } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"
import Papa from "papaparse"
import { useEffect, useState } from "react"

import { Table } from "@bounce/web-components"

/**
 * Props for `Csv`.
 */
export type CsvProps = SliceComponentProps<Content.CsvSlice>

/**
 * Component for "TableLegacy" Slices.
 * This slice need to be migrate to the latest slice machine version.
 */
const Csv = ({ slice }: CsvProps): React.JSX.Element => {
  const [data, setData] = useState<string[][]>()
  const csv_file = slice.primary.csv_file as LinkToMediaField<"filled">

  useEffect(() => {
    if (data || !csv_file.url) return

    // Download and parse the CSV file
    Papa.parse(csv_file.url, {
      download: true,
      complete: results => {
        setData(results.data as string[][])
      },
    })
  }, [data, csv_file.url])

  return <Table data={data ?? []} className="my-12 max-h-[80vh] rounded-lg" />
}

export default Csv
